import { generatePDF, pluralizeText, retrieveFromStorage } from "./utilities";

import $ from "jquery";
import { getLanguage } from "./utilities";

const lang = getLanguage();
const printReportButton = $("#print-report");

function initPrintButton() {
    printReportButton.on("click", () => print());
}

function populatePDF() {
    const inputs = retrieveFromStorage("assetallocation");

    if (inputs) {
        generatePDF(inputs);

        $("[data-output-pluralize-text]").each(function () {
            const count = Number($(this).closest("p, td").find("[data-output-number]").text());

            let word = $(this).text();
            if (word.slice(-1) === "s") {
                word = word.slice(0, word.length - 1);
            }

            $(this).text(pluralizeText(word, count, false).trim());
        });

        const {
            timeToRecover: { timePeriod }
        } = inputs;
        if (timePeriod === 1) {
            const text = lang === "en" ? "1 year" : "1 an";
            $("[data-id='timeToRecoverDescription']").text(text);
            $("[data-id='threeYearValue']").hide();
            $("[data-id='fiveYearValue']").hide();
        } else if (timePeriod === 3) {
            const text = lang === "en" ? "1 and 3 years" : "1 an et 3 ans";
            $("[data-id='timeToRecoverDescription']").text(text);
            $("[data-id='threeYearValue']").show();
            $("[data-id='fiveYearValue']").hide();
        } else {
            const text = lang === "en" ? "1, 3 and 5 years" : "1 an, 3 ans et 5 ans";
            $("[data-id='timeToRecoverDescription']").text(text);
            $("[data-id='threeYearValue']").show();
            $("[data-id='fiveYearValue']").show();
        }
    }
}

$(() => {
    if ($(".print-page-wrapper").length) {
        initPrintButton();
        populatePDF();
    }
});

export { populatePDF };
